export default __webpack_public_path__ + "static/media/1280px-Weatherford_International_Logo.svg.1f620fed.png";